import storyDrawerTemplate from './story.drawer.html';

function storyDrawerService(
  _,
  $q,
  $log,
  $transitions,
  $translate,
  $uibModal,
  storiesService,
  tasksService,
  storyPitchingService,
  storyProcessingService,
  analyticsService,
  platformService
) {
  const service = {
    modal: null,
    story: null,
    tab: null,
    callbacks: null,
    data: null
  };

  const eventTypes = {
    preview: {
      name: $translate.instant('OPEN_PREVIEW_STORY_DRAWER')
    },
    pitches: {
      name: $translate.instant('OPEN_MANAGE_PITCHES_DRAWER')
    },
    tasks: {
      name: $translate.instant('OPEN_MANAGE_TASKS_DRAWER')
    },
    metadata: {
      name: $translate.instant('OPEN_METADATA_STORY_DRAWER')
    },
    pitch: {
      name: $translate.instant('PITCHED_STORY')
    },
    withdrawPitch: {
      name: $translate.instant('WITHDREW_STORY_PITCH')
    }
  };

  service.trackDrawerEvent = (story, event) => {
    let eventType = _.get(eventTypes, `${event}.name`);
    if (!eventType) {
      eventType = event;
    }
    analyticsService.trackEvent('Drawer open', eventType);
  };

  service.getStoryData = (drawerStory, data) => {
    const story = drawerStory;
    const deferred = $q.defer();

    if (!story) {
      deferred.reject('Story or story Id is missing');
    }

    if (angular.isObject(story)) {
      storyPitchingService.calculateAvailablePitches(story);
      deferred.resolve(story);
    } else {
      $q.all([
        storiesService.getStory(story),
        platformService.getAll(),
        tasksService.getTasksByStoryId(story)
      ]).then((dataParam) => {
        const storyCalc = storyPitchingService.calculateAvailablePitches(storyProcessingService
          .cleanStory(dataParam[0]), dataParam.channel);
        storyCalc.tasks = data[2];
        deferred.resolve(storyCalc);
      }, (response) => {
        $log.error('storyDrawerService $q.all() error', response.error || response);
        deferred.resolve($translate.instant('ERROR_GETTING_STORY_DATA'));
      });
    }

    return deferred.promise;
  };

  service.open = (story, tab, callbacks, data, hidePanel) => {
    service.trackDrawerEvent(story, tab || 'preview');

    service.tab = tab;
    service.callbacks = callbacks;
    service.data = data;

    service.getStoryData(story, data).then(
      (storyParam) => {
        service.story = storyParam;

        if (!service.modal) {
          service.modal = $uibModal.open({
            template: storyDrawerTemplate,
            controller: 'StoryDrawerController',
            windowClass: 'story-drawer',
            keyboard: false,
            resolve: {
              story() {
                return storyParam;
              },
              tab() {
                return tab;
              },
              data() {
                return data;
              },
              hidePanel() {
                return hidePanel;
              }
            }
          });

          service.modal.result.then((dataParam) => {
            if (callbacks && callbacks.ok) {
              callbacks.ok(dataParam);
            }
            service.modal = null;
          }, (dataParam) => {
            if (callbacks && callbacks.cancel) {
              callbacks.cancel(dataParam);
            }
            service.modal = null;
          });
        }
      },
      (error) => {
        if (callbacks && callbacks.error) {
          callbacks.error(error);
        }
      }
    );
  };

  service.close = (result) => {
    if (service.modal) {
      service.modal.close(result);
    }
  };

  service.dismiss = (result) => {
    if (service.modal) {
      service.modal.dismiss(result);
    }
  };

  $transitions.onStart({}, () => {
    service.dismiss();
  });

  return service;
}

const arr = [
  '_',
  '$q',
  '$log',
  '$transitions',
  '$translate',
  '$uibModal',
  'storiesService',
  'tasksService',
  'storyPitchingService',
  'storyProcessingService',
  'analyticsService',
  'platformService',
  storyDrawerService
];

export default function (ngModule) {
  ngModule.factory('storyDrawerService', arr);
}
